import { useEffect } from "react";
import { atom, useSetRecoilState } from "recoil";

// 카드결제 iframe(UrPay=cross-origin Flutter Web) 진행 중 여부.
// iframe 내부의 터치/키 입력은 부모 문서로 버블링되지 않으므로, 활동 감지 기반 idle 타이머는
// 결제 중 "활동 없음"으로 오인해 오발동한다. 따라서 결제 중에는 이 플래그로 타이머를 정지한다.
export const paymentActiveState = atom<boolean>({
  key: "paymentActiveState",
  default: false,
});

// idle 타이머를 일시정지해야 하는 화면(Thankyou/OrderReview 등 종료·읽기전용)에서 true.
export const idlePausedState = atom<boolean>({
  key: "idlePausedState",
  default: false,
});

// 장바구니 마지막 변경 시각(ms epoch). 제출 시점 stale 확인(①)에 사용. 0 = 아직 변경 없음.
export const lastCartTouchState = atom<number>({
  key: "lastCartTouchState",
  default: 0,
});

// 화면 마운트 동안 IdleGuard(②)를 일시정지한다(종료·읽기전용 화면: Thankyou/OrderReview).
export function usePauseIdleGuard() {
  const setPaused = useSetRecoilState(idlePausedState);
  useEffect(() => {
    setPaused(true);
    return () => setPaused(false);
  }, []);
}
